module.exports = __webpack_public_path__ + "img/Apple-app.1461dfd6.png";